import { FaceAgentIcon } from './FaceAgentIcon';

/**
 * author: Mark Joseph Monserrat
 * id 3E0B74E0-1F0F-4820-A02F-B370CD56E463
 * name face-agent
 * version: 3.4.93
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/face-agent.svg
 * tags
 */
export const EmojiAgentIcon = FaceAgentIcon;
export default EmojiAgentIcon